import React, { useState, useEffect, useMemo } from 'react';
import Table from '../partials/Table';
import axios from 'axios'
import styled from 'styled-components';

function PixelsTable({ startDate, endDate, loadingData, setLoadingData }) {

    const [data, setData] = useState();

    useEffect(() => {
        console.log(loadingData)
        if (loadingData) {
            // if the result is not ready so you make the axios call
            getPixels();
        }
    }, [loadingData]);

    const getPixels = () => {
            axios.post(`${process.env.REACT_APP_API_URL || ''}/getPixels`, { dates: [startDate, endDate] })
            .then(response => {
                setData(response.data);
                setLoadingData(false);
            }
            )
            .catch(error => console.log('api errors:', error));
    }

    const columns = useMemo(
        () => [
            {
                Header: 'URL',
                accessor: 'url',
            },
            {
                Header: 'Date',
                accessor: 'created_at',
            }
        ], []
    );

    return (
        <div>
            <p><strong>Start Date:</strong> {startDate}</p>
            <p><strong>End Date:</strong> {endDate}</p>
            <>
            {loadingData ? (
                <p>Loading Please wait...</p>
            ) : (
                <Styles>
                    <Table className="pixelTable" columns={columns} data={data} />
                </Styles>
            )}
        </>
        </div>
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const Styles = styled.div`
  padding: 1rem 0;

  table {
    border-collapse: separate;
    border: 1px solid #66BFBF;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #66BFBF;
      border-right: 1px solid #66BFBF;
      :last-child {
        border-right: 0;
      }
    }
   
  }
`;

PixelsTable.defaultProps = {
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
};

export default PixelsTable;